/*jshint scripturl:true*/
import React, {Component} from 'react';
import axios from 'axios';
import auth0Client from '../Auth';
import {ToastContainer, ToastStore} from 'react-toasts';
import {   withRouter } from "react-router-dom";
//import Claims from '../Claims/Claims';
import {SERVER_URL}  from '../Constants';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { CSVExport, Search } from 'react-bootstrap-table2-toolkit';
import LostItemFunctions from '../LostItem/LostItemFunctions';
//import { DH_NOT_SUITABLE_GENERATOR } from 'constants';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter, numberFilter } from "react-bootstrap-table2-filter";
import Cookies from 'universal-cookie';
import Toggle from "react-toggle-component"
import ShippingRequestTable from './Components/ShippingRequestTable';
import Modal from 'react-responsive-modal';

const cookies = new Cookies();
const { ExportCSVButton } = CSVExport;
const { SearchBar } = Search;
const FILTER_COOKIE_NAME = 'initialShippingFilter';

const paginationOption = {
  custom: true,
  sizePerPage: 100
};

function afterFilter(newResult, newFilters) {
  //console.log(newResult);
  //console.log(newFilters);
}


  function formatCountry(cell,row){
    try {
        if (cell){
            
            return (
                <div>
                    {cell} <br/>
                <img style={{width:16, height:12}} alt='' src={'./images/' + cell.toLowerCase() + '.png'}/> 
                </div>
             );

        }else{
            return  '---';
        }
    }catch(e){
        return  '---';

    }
  }
  

  function formatLink(cell,row){
    try {
        if (cell){
            
            return (
                <a className = "text-info" href={"javaScript: window.open('" + cell + "')"}> <b>link</b></a>
             );

        }else{
            return  '---';
        }
    }catch(e){
        return  '---';

    }
  }

  

  function formatBool(cell,row){
    try {
        if (cell){
            
            return (cell) ? 'YES' :' NO';
        }else{
            return  'NO';
        }
    }catch(e){
        return  'NO';

    }
  }

 

  function formatLinktoSend(cell, row){
    
    try {
      if (cell){
          
          return (
            <small>{"https://bounteapi.com/Shipping/startshipping/" + cell}</small>  
           );

      }else{
          return  '---';
      }
  }catch(e){
      return  '---';

  }
    
   
  }


  function formatFeeAmount (cell,row){
    try {
        if (cell){
           
            //return Math.round(parseFloat(cell)/100,2);
            //return formatter.format(parseFloat(cell));
            var str = parseFloat(cell);
            return str+ ' (USD)';
        }else{
            return  '';
        }
    }catch(e){
        return  '';

    }
  }
  function formatStripeAmount (cell,row){
    try {
        if (cell){
           
            //return Math.round(parseFloat(cell)/100,2);
            //return formatter.format(parseFloat(cell)/100);
            var str = parseFloat(cell)/100;
            return str + ' (' + row.currency.toUpperCase() +')';
        }else{
            return  '';
        }
    }catch(e){
        return  '';

    }
  }



  const defaultSorted = [{
    dataField: 'updatedOn',
    order: 'desc'
  }];
  

  class ShipCentral extends Component {


    

    constructor(props) {
      super(props);

      let initialShippingFilter= cookies.get(FILTER_COOKIE_NAME);
      let defaultFilter = (initialShippingFilter) ? initialShippingFilter:'';
      
      this.state = { 
          results: [],
          selectedRows:[],
          filteredItems:[],
          useColumnFilters:(cookies.get('useParcelColumnFilters')==='true') ? true : false,
          filter:defaultFilter,
          includeCancelled:(cookies.get('includeCancelled')==='true') ? true : false,
          displayShippingRequest:false,
          shippingRequest:{}
        }
        this._input = null;

    }
    async componentDidMount() {


        // console.log("Component did load. Auth : " + auth0Client.getIdToken());
         
         this.loadShipData();
       
     
       }

        cancelRefund=(row)=>{

          const cancelFlag = window.confirm("Are you sure you want to cancel and refund?");
          if (!cancelFlag){
              return;
          }
          let excludePackingFee = true;
          //if (row.additionalPackingFee){
          //  excludePackingFee = window.confirm("It appears there is an additional package fee.  Would you like to EXCLUDE this from the refund? Press OK to include or Cancel for no");
          //}

           
            try {
                axios.post(`${SERVER_URL}/Shipping/cancelrefund`,{
                        id: row.id,
                        excludePackingFee:excludePackingFee,
                    },
                    {  
                        headers: { 
                        'Authorization': `Bearer ${auth0Client.getIdToken()}`,
                        'venueId' : auth0Client.getActiveVenuedId()
                      }

                    }
                  
                  ).then((res)=>{
                    
                    if (res.status === 200) {
                        ToastStore.success('Item will be cancelled! ** NOTE:  Please allow up to an hour+ for the carriers to process the request.  You can check the status of the cancellation by returning to this screen.');
                     
                     }else{
                        ToastStore.error("An error occured: " + res.response.statusText);
                     }
            
                  
                   
                 
       
                   });
            }catch(e){
                alert(e.message);
            }
        
     }
    

     customTextFilter =()=>{
      if (this.state.useColumnFilters){
        return(
          textFilter(
            {
              delay: 600, // default is 500ms
              style: {
                backgroundColor: 'white'
              },
              className: 'form-control form-control-sm',
              placeholder: '',
             // onClick: e => console.log(e)
            }
          )
        )
      } else{
        return null;
      }   
     
    }
  
    resendTrackingAndReceipt=(row)=>{
      const cancelFlag = window.confirm("Are you sure you want to resend the tracking and receipt?");
      if (!cancelFlag){
          return;
      }
      try {
        axios.post(`${SERVER_URL}/Shipping/resendtrackingandreceipt`,{
                shipmentId: row.id
            },
            {
              headers: {
                'Authorization': `Bearer ${auth0Client.getIdToken()}`,
                'venueId' : auth0Client.getActiveVenuedId()
              }
            }
          ).then((res)=>{
            if (res.status === 200) {
                ToastStore.success('Email resent successfully');
              }else{
               //alert(res.response.statusText);
               // Display error
                console.log(res.response.statusText);

               
               ToastStore.error("An error occured: " + res.response.statusText);
              }
            });
      }catch(e){
          alert(e.message);
      }
    }

    customNumberFilter=()=>{
      if (this.state.useColumnFilters){
      return(
        numberFilter(
          {
            delay: 600, // default is 500ms
            style: {
              backgroundColor: 'white',
              width: '280px'
            },
            withoutEmptyComparatorOption: true,
            //comparators: [Comparator.EQ, Comparator.GT, Comparator.LT],
            className: 'custom-numberfilter-class',
            comparatorClassName: 'form-control form-control-sm',
            numberClassName: ' form-control-sm',
            placeholder: '',
            //onClick: e => console.log(e)
          }
        )
      )
        }else{
          return null
        }
  
    }

    cancelRequest = (row)=>{  

      // Enter the reason for the cancellation
      const reason = window.prompt("Please enter the reason for the cancellation");
      // null is cancel button
      if (reason===null){
          return;
      }
    
      try {
        axios.post(`${SERVER_URL}/Shipping/cancelshippingrequest`,{
                shipmentId: row.id,
                cancelReason:reason,
              
            },
            {
              headers: { 
                'Authorization': `Bearer ${auth0Client.getIdToken()}`,
                'venueId' : auth0Client.getActiveVenuedId()
              }
            }

          ).then((res)=>{

            if (res.status === 200) {
                ToastStore.success('Request cancelled successfully');

              }else{
                ToastStore.error("An error occured: " + res.response.statusText);
              }

          });
      }catch(e){
          alert(e.message);
      }
    }




      formatPurchased=(cell, row)=>{
        try {
//console.log(row)
          if (row.isCancelled){
            return(
              <div><span className='text-danger'><b>Cancelled</b></span></div>
              
            )
          }

          if (cell){
              if (cell===true){
                  return(
                      //<a href={"javaScript:cancelRefund('" + cell + "')"}>Cancel-Refund </a>
                     //<button type="button" className="btn btn-outline-danger btn-sm ml-2 ts-buttom" size="sm" onClick={this.cancelRefund(row.id)}> Cancel-Refund </button>
                     <button type="button" className="btn btn-outline-danger btn-sm ml-2 ts-buttom" size="sm" disabled={auth0Client.lfReadOnly===true} onClick={()=>this.cancelRefund(row)}> Cancel & Refund </button>
  
                  )
              }else{
                return(
                    <button type="button" className="btn btn-outline-warning btn-sm ml-2 ts-buttom" size="sm" disabled={auth0Client.lfReadOnly===true} onClick={()=>this.cancelRequest(row)}> Cancel </button>
                )
              }
          }else{
           
              return(
                  <button type="button" className="btn btn-outline-warning btn-sm ml-2 ts-buttom" size="sm" disabled={auth0Client.lfReadOnly===true} onClick={()=>this.cancelRequest(row)}> Cancel </button>
              )
           
          }
  
        }catch(e){
  
        }
    }

    formatClaimButton=(cell, row)=>{
      //console.log(row)
        return (
          <button type="button" className="btn btn-link btn-sm ml-2 ts-buttom" size="sm" onClick={()=>this.gotoClaim(row)}>Goto Claim</button>
        )
    

    };
    formatResendButton=(cell, row)=>{
      //console.log(row)
      if (row.status!=='SUCCESS'){
        return (
          <button type="button" className="btn btn-outline-info btn-sm ml-2 ts-buttom text-center" size="sm" onClick={()=>this.resendShippingRequest(row)}>Resend</button>
        )
      }else{
        return (
          <button type="button" className="btn btn-outline-success btn-sm ml-2 ts-buttom text-center" size="sm" onClick={()=>this.resendTrackingAndReceipt(row)}>Resend Tracking</button>
        )
      }

    };

    showShippingRequest=(row)=>{
      //console.log(row)
      this.setState({displayShippingRequest:true, shippingRequest:row.shipmentRequest});
    }


    formatShippingRequestLink=(cell, row)=>{
      // Check if there is a shipment object

      // Create a small button to display modal with the shipment details
      //console.log(row)
      return (
        <button type="button" className="btn btn-link btn-sm ml-2 ts-buttom" size="sm" onClick={()=>this.showShippingRequest(row)}>Details</button>
      )
    }
    resendShippingRequest=(row)=>{
   
      const cancelFlag = window.confirm("Are you sure you want to resend the request?");
      if (!cancelFlag){
          return;
      }
     
      try {
        axios.post(`${SERVER_URL}/Shipping/resendshippingrequest`,{
                shipmentId: row.id,
               
            },
            {  
                headers: { 
                'Authorization': `Bearer ${auth0Client.getIdToken()}`,
                'venueId' : auth0Client.getActiveVenuedId()
              }

            }
          
          ).then((res)=>{
            
            if (res.status === 200) {
                ToastStore.success('Email resent successfully');
             
             }else{
                ToastStore.error("An error occured: " + res.response.statusText);
             }

           });
    }catch(e){
        alert(e.message);
    }
    };

    gotoClaim=(row)=>{
    
        this.props.history.push('/Claim/' + row.claimId );
        return;
    
    }




     getColumns=()=>{


        return [

                  { dataField: 'updatedOn',sort: true,formatter: LostItemFunctions.formatDateTime,  text: 'Last Updated',  headerStyle: (colum, colIndex) => {return { width: '120px', textAlign: 'center',  overflow: "hidden", textOverflow: 'ellipsis' };}},
            
            
                { dataField: 'to',sort: true, text: 'Shipping To',filterable:true,filter: this.customTextFilter(), classes:'text-primary', textAlign: 'left', headerStyle:{overflow: "hidden", width:'200px'}},
                { dataField: 'shipTo',sort: true, text: 'Address',filterable:true, filter: this.customTextFilter(), classes:'text-primary', textAlign: 'left',  headerStyle:{overflow: "hidden", textOverflow: 'ellipsis',  width:'400px'}},
                { dataField: 'shipCountry',sort: true, text: 'Country',formatter:formatCountry,filterable:true, filter: this.customTextFilter(), classes:'text-primary', textAlign: 'left',  headerStyle:{overflow: "hidden", width: '100px'}},
            
                { dataField: 'guestViewedShipping', sort: true, formatter: formatBool, text: 'Viewed Email', classes:'text-primary', textAlign: 'left',  headerStyle:{overflow: "hidden",width: '100px', textOverflow: 'ellipsis'}},
                { dataField: 'invoiceUrl', sort: true, formatter: this.formatResendButton, text: 'Resend', classes:'text-primary', textAlign: 'left',  headerStyle:{overflow: "hidden",width: '170px', textOverflow: 'ellipsis'}},

                { dataField: 'guestPurchasedLabel', sort: true, formatter: this.formatPurchased, text: 'Purchased Label?', classes:'text-primary', textAlign: 'left',  headerStyle:{overflow: "hidden",width: '170px', textOverflow: 'ellipsis'}},
                { dataField: 'status', sort: true, text: 'Purchase Status',filterable:true,filter: this.customTextFilter(), classes:'text-primary', textAlign: 'left',  headerStyle:{overflow: "hidden",width:"180px", textOverflow: 'ellipsis'}},
                { dataField: 'purchaseDate', sort: true,formatter: LostItemFunctions.formatDateTime, text: 'Purchased On', classes:'text-primary', headerStyle:{overflow: "hidden",width: '200px', textOverflow: 'ellipsis'}},
                { dataField: 'claimId', sort: true, text: 'Claim', formatter:this.formatClaimButton, classes:'text-primary', textAlign: 'center',  headerStyle:{overflow: "hidden",width: '100px', textOverflow: 'ellipsis'}},
                { dataField: 'trackingLinkUrl', sort: true,formatter:formatLink, text: 'Tracking', classes:'text-info', textAlign: 'center',  headerStyle:{overflow: "hidden",width: '120px', textOverflow: 'ellipsis'}},
               // { dataField: 'invoiceUrl', sort: true, formatter:formatLink, text: 'Carrier Invoice', classes:'text-primary', textAlign: 'center',  headerStyle:{overflow: "hidden",width: '200px', textOverflow: 'ellipsis'}},
               // { dataField: 'messages', sort: true, text: 'Messages',formatter:formatStringArray, classes:'text-primary', textAlign: 'left',  headerStyle:{overflow: "hidden",width: '200px', textOverflow: 'ellipsis'}},
                //{ dataField: 'trackingStatus', sort: true, text: 'Tracking Status', classes:'text-primary', textAlign: 'left'},
                
                { dataField: 'amount', sort: true,formatter:formatStripeAmount, text: 'amount',  textAlign: 'right',headerStyle:{overflow: "hidden",width: '150px', textOverflow: 'ellipsis'}, footer: columnData => columnData.reduce((acc, item) => acc + item, 0), footerFormatter: formatStripeAmount,},
                { dataField: 'shippingFee', sort: true,formatter:formatFeeAmount, text: 'Shipping Fee',  classes:'text-primary', textAlign: 'right',headerStyle:{overflow: "hidden",width: '150px', textOverflow: 'ellipsis'}, footer: columnData => columnData.reduce((acc, item) => acc + item, 0)},
                { dataField: 'additionalPackingFee', sort: true,formatter:formatFeeAmount, text: 'Packing Fee', classes:'text-primary', textAlign: 'right',headerStyle:{overflow: "hidden",width: '150px', textOverflow: 'ellipsis'}, footer: columnData => columnData.reduce((acc, item) => acc + item, 0)},
                { dataField: 'id', sort: true,formatter:formatLinktoSend, text: 'Customer Payment Link', classes:'text-primary', textAlign: 'left', headerStyle:{ width:'400px'}},
                { dataField: 'cancelledAt', sort: true, formatter: LostItemFunctions.formatDateTime, text: 'Cancelled On', classes:'text-primary', textAlign: 'left', headerStyle:{ width:'150px'}},
                { dataField: 'cancelReason', sort: true, text: 'Cancel Reason', classes:'text-primary',filterable:true, filter: this.customTextFilter(), textAlign: 'left', headerStyle:{ width:'150px'}},
                { dataField: 'shipmentRequest', sort: true, text: 'Details',formatter:this.formatShippingRequestLink, classes:'text-primary',filterable:true, filter: this.customTextFilter(), textAlign: 'left', headerStyle:{ width:'150px'}},
       
                
            
            
            ];
            }


       loadShipData = () =>{
        try {
          axios.get(`${SERVER_URL}/Shipping/ShippingCentral?includeCancelled=${this.state.includeCancelled}` ,{
             headers: { 
               'Authorization': `Bearer ${auth0Client.getIdToken()}`,
               'venueId' : auth0Client.getActiveVenuedId()
             }
           }).then((res)=>{
             
             if (res.status === 401) {
               //place your reentry code
               console.log("Error" + res.status);
              
              }
     
             const results = res.data.results;
            
             

             this.setState({
              results : results,
               
              });


            });
        }catch(e){

        }
    }

     
   

    openUrl=(url)=>{
        window.open(url);
        }


    renderToast=()=>{
        return <div>
            
            <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
        </div>
      }

      print=()=>{
       
            // STEP 1: Create a new window, a div, and append it to the window. The div 
            // *MUST** be created by the window it is to be appended to (Edge only)
          

            this.externalWindow = window.open('', '', 'width=600,height=400,left=200,top=250');
            var ss = document.createElement("link"); ss.type = "text/css"; ss.rel = "stylesheet"; ss.href = "https://bootswatch.com/4/lux/bootstrap.min.css"; 
            this.externalWindow.document.getElementsByTagName("head")[0].appendChild(ss);


            this.containerEl = this.externalWindow.document.createElement('div');
            this.externalWindow.document.body.appendChild(this._input);
        
      }

    
      renderShippingRequestModal=()=>{
        return (
          <Modal  open={this.state.displayShippingRequest} onClose={()=>this.setState({displayShippingRequest:false})}>
            <div style={{width:'600px', height:'500px', overflow: 'auto'}}>
                <ShippingRequestTable shippingRequest={this.state.shippingRequest}/>
            </div>
          </Modal>
        );
      }

      renderAdvancedGrid=()=>{
        return (
  
          <div>
          {this.state.filteredItems === null && <p>Loading Parcels...</p>}
         
          <ToolkitProvider 
                bootstrap4
                keyField='id' 
                data={ this.state.filteredItems } 
                columns={ this.getColumns(this.state.venueTypeCd) } 
                
                defaultSorted={defaultSorted}
                search={ {
                  searchFormatted: false
                } } 
               
              >
          {
            props => (
              <div>
                 <SearchBar { ...props.searchProps } />
                 <BootstrapTable
            className="table-sm"
            ref={this.tableRef}
            filter={ filterFactory({afterFilter}) }  
            striped
            hover
            condensed
           
            rowEvents={this.rowEvents}
            /*selectRow={ { 
                  mode: 'checkbox', 
                  clickToSelect: true, 
                  hideSelectColumn: true,
                  onSelect: (row, isSelect, rowIndex, e) => {
                    if (e.target.tagName.toLowerCase() === 'img'){
                      //console.log('onSelect');
                      e.stopPropagation(); //dont check
                      this.setState({
                        selectedImageUrl : e.target.src,
                        displayLargeImageModal:true});
                      
                      return;
                  }
                }}}*/
            selectRow={ { 
              mode: 'checkbox', 
              clickToSelect: true, 
              selected:this.state.selectedRows,
          
              onSelect: (row, isSelect, rowIndex, e) => {
                if (e.target.tagName.toLowerCase() === 'img'){
                  //console.log('onSelect');
                  e.stopPropagation(); //dont check
                  this.setState({
                    selectedImageUrl : e.target.src,
                    displayLargeImageModal:true});
                    
                  return;
                }
      
                  let index = this.state.selectedRows.indexOf(row.id);  
                  if (isSelect){
                    if (index===-1) {
                      this.state.selectedRows.push(row.id);
                    }
                  }else { this.state.selectedRows.splice(index, 1) }
                
                this.setState({
                  checkedCount:this.state.selectedRows.length,
                  actionButtonDisabled:(this.state.selectedRows.length===0)
                })
              },
              onSelectAll: (isSelect, rows, e) => {
                let selectedRowList = this.state.selectedRows;
                selectedRowList.length=0; //cleared
                //this.cleanSelectedCheckboxes();
                if (isSelect){
                  // clear and loop and add each
                  
                  for(var i=0;i<rows.length; i++) { this.state.selectedRows.push(rows[i].id)}
                }else{
                  this.setState({selectedRows:[]});
                }
                this.setState({
                  checkedCount:this.state.selectedRows.length,
                  actionButtonDisabled:(this.state.selectedRows.length===0)
                })
              },
              selectionRenderer: (props) => (
                <input
                    style={{width:'20px', height:'20px', alignSelf:'center'}}
                    type={props.mode}
                    checked={props.checked}
                    onChange={()=>{}}
                />
              )
         
            }}
          
           { ...props.baseProps }
           pagination={ paginationFactory(paginationOption) }
         />
              </div>
      
            )
            
            }
          </ToolkitProvider>
      
         
      
      </div>
      
        )
      }


      renderGrid=()=>{
        return (
    
          <div className='row'>
                <div className='col'> <h3>Shipments </h3></div>
                
                <div className='col-2 text-right'>
                    <Toggle id='expensive' labelRight="Column Filters" checked={this.state.useColumnFilters} onToggle={value => this.setState({useColumnFilters:value}, ()=>{ 
                      if (cookies){
                        //console.log('setting user cooke:' + filter);
                        cookies.set('useParcelColumnFilters', this.state.useColumnFilters);
                      }
                    })} /> 
                </div>
                <div className='col-2 text-right'>
                    <Toggle id='includeCancelled' labelRight="Include Cancelled" checked={this.state.includeCancelled} onToggle={value => this.setState({includeCancelled:value}, ()=>{ 
                      if (cookies){
                        //console.log('setting user cooke:' + filter);
                        cookies.set('includeCancelled', this.state.includeCancelled);
                      }
                      this.loadShipData();  
                    })} /> 
                </div>  
          <div>
 
           
           
         
           {this.state.lostItems === null && <p>Shipment Details...</p>}
            <ToolkitProvider 
            bootstrap4
              keyField='id' 
              data={ this.state.results } 
              columns={ this.getColumns() } 
              exportCSV
              defaultSorted={defaultSorted}
              search
              >
              {
        props => (
          <div>
          <SearchBar { ...props.searchProps } />
       
       <hr />
           <ExportCSVButton { ...props.csvProps }>Export CSV for Printing</ExportCSVButton>
         
            <BootstrapTable
            
              striped
              condensed
              class="table-responsive"
              filter={ filterFactory({afterFilter}) }  
              { ...props.baseProps }
              pagination={ paginationFactory({sizePerPage:50}) }
            />
          </div>
        )
             }</ToolkitProvider>
    
          </div>
    
          </div>
        )
    
      
      }
    

    render(){

        return(
     
            <div className="w-100 p-3" ref={c => (this._input = c)}> 
            
           
              {this.renderToast()}
              {this.renderGrid()}
              {this.renderShippingRequestModal()}
            
            </div>

        )



    }
}


export default withRouter(ShipCentral);